import React, { useState, useEffect } from "react";
import { AppLoad } from "../../../core/AppLoad";
import { AppConfig } from "../../../app-state";
// import { ListItem } from "./ListItem";
import { useParams, NavLink, useHistory, Link } from "react-router-dom";
import { Icon } from "../../../core/Icon";
import { Spinner } from "../../../core/Spinner";
// export const RoleOptions = [
//     { value: 'admin', label: 'Administrátoři' },
//     { value: 'individual', label: 'Fyzické osoby' },
//     { value: 'legal', label: 'Právnícké osoby' },
//     // { value: 'joint', label: 'Páry' },
//     // { value: 'trust', label: 'Fyzické osoby' },
// ]
export const UserManagement = () => {
    // const { state, dispatch } = useContext(AppStateContext);
    const [accounts, setAccounts] = useState(null);
    // const [selectedId, setSelectedId] = useState(null);
    const [isLoading, updateLoading] = useState(true);
    const [sizePerPage, setSizePerPage] = useState(40);
    const [offset, setOffset] = useState(0);
    const { urlRole, urlAccountId } = useParams();
    let history = useHistory();
    const listLoad = () => {
        const data = { offset: offset, sizePerPage: sizePerPage, role: urlRole };
        AppLoad(AppConfig.APIUrl + 'admin/user-management/list', data).then((Response) => {
            if (Response.status == 'ok') {
                setAccounts(Response.Data);
            }
            updateLoading(false);
        });
    };
    useEffect(() => {
        document.title = 'Správa uživatelů' + AppConfig.titleSufix;
        listLoad();
    }, [urlRole]);
    const headings = [
        { title: "ID", attr: "id" },
        { title: "Jméno a příjmení", attr: "fullname" },
        { title: "Email", attr: "email" },
        { title: "Telefon", attr: "phone", className: "text-right" },
    ];
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "flex-space" },
            React.createElement("div", { className: "t1" },
                React.createElement("h1", { className: "page-title" }, "Spr\u00E1va u\u017Eivatel\u016F")),
            urlRole == 'admin' &&
                React.createElement("div", { className: "t3" },
                    React.createElement(Link, { to: "/cs/sekce/administrator/novy", className: "cta-plus" },
                        "P\u0159idat administr\u00E1tora",
                        React.createElement(Icon, { c: ['plus-circle', 24, 24] })))),
        React.createElement("div", { className: "tabs" },
            React.createElement(NavLink, { className: "tab-item", to: "/cs/sekce/sprava-uzivatelu/admin" }, "Administr\u00E1to\u0159i"),
            React.createElement(NavLink, { className: "tab-item", to: "/cs/sekce/sprava-uzivatelu/individual" }, "Fyzick\u00E9 osoby"),
            React.createElement(NavLink, { className: "tab-item", to: "/cs/sekce/sprava-uzivatelu/legal" }, "Pr\u00E1vnick\u00E9 osoby"),
            React.createElement(NavLink, { className: "tab-item", to: "/cs/sekce/sprava-uzivatelu/trust" }, "Spole\u010Dn\u00ED \u00FA\u010Dastn\u00EDci")),
        isLoading ?
            React.createElement(Spinner, null)
            :
                React.createElement("div", { className: "smart-table" },
                    React.createElement("table", null,
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "ID"),
                                React.createElement("th", null, urlRole == "legal" ? "IČ" : "Rodné číslo"),
                                React.createElement("th", null, urlRole == "legal" ? "Obchodní firma" : "Jméno a příjmení"),
                                React.createElement("th", null, "Email"),
                                React.createElement("th", { className: "text-right" }, "Telefon"))),
                        React.createElement("tbody", null, accounts && accounts.map((data, key) => {
                            return React.createElement("tr", { key: key },
                                React.createElement("td", null, data.id),
                                React.createElement("td", null, urlRole == "legal" ? data.regNo : data.bornId),
                                React.createElement("td", null,
                                    React.createElement(Link, { className: "hyperlink", to: "/cs/sekce/profil/" + data.id }, urlRole == "legal" ? data.company : data.fullname)),
                                React.createElement("td", null, data.email),
                                React.createElement("td", { className: "text-right" }, data.phone));
                        }))))));
};
/*


            <div className="record-catalogue mb-40">
                <div className="record-catalogue-list">

<div className="account-list">

    </div>
                </div>











var UserManagementCtrl = {
    Load: function () {
        var Data = AppHelper.DataGridApi(AppState.UserManagement.DataGrid);
        AppState.UserManagement.DataGridLoading = "loading";

        $.when(
            AppTransfer.Start('/Api/Secured/UserManagement/Table', Data)
        ).done(function (Response) {
            if (Response.status == 'ok') {
                AppState.UserManagement.DataGrid.Data = Response.Data;
                AppState.UserManagement.DataGrid.total = Response.total;
                AppState.UserManagement.DataGridLoading = null;
                AppRender();
            }
        });
    },
    itemCheck(id) {
        if (AppState.UserManagement.Selected.includes(id)) {
            AppState.UserManagement.Selected = AppState.UserManagement.Selected.filter((o) => o !== id);
        } else {
            AppState.UserManagement.Selected.push(id);
        }
        AppRender();
    },
    EraseSelected() {
        AppConfirm('Are you sure you want to remove ' + AppState.UserManagement.Selected.length + ' accounts?',
            UserManagementCtrl.EraseConfirmed,
            AppModal.Hide
        );
    },
    EraseConfirmed() {
        // AppState.AdminsEdit.formStatus = "loading";
        AppModal.Hide();
        var Data = new FormData();
        Data.append('ids', AppState.UserManagement.Selected);
        // var Data = AppHelper.gatherFormData(AppState.AdminsEdit.Form);
        $.when(AppTransfer.Start('/Api/Secured/UserManagement/Erase', Data)).done(function (response) {
            if (response.status == 'ok') {
                AppStatus.Success(AppState.UserManagement.Selected.length + ' account(s) removed');
                AppState.UserManagement.Selected = [];
                UserManagementCtrl.Load();
                // AppState.AdminsEdit.formStatus = "erased";
                // AppModal.HideDelay();
                // AppState.appInstance++;
                // AppRender('Application Reload');

            }
        });
    },
    SelectAll() {
        AppState.UserManagement.Selected = [];
        for(let i=0; i<AppState.UserManagement.DataGrid.Data.length;i++){
            AppState.UserManagement.Selected.push( AppState.UserManagement.DataGrid.Data[i].id);
        }
        AppRender();
    },
    SelectNone() {
        AppState.UserManagement.Selected = [];
        AppRender();
    }
}

class UserManagementView extends React.Component {
    componentWillMount() {
        AppState.UserManagement = {
            Selected: [],
            Form: {
                id: { value: null },
            },
            DataGrid: {
                page: 1,
                sizePerPage: 20,
                Data: [],
                total: null,
                Reload: UserManagementCtrl.Load
            }
        }
    }

    componentDidMount() {
        document.title = AppState.titlePrefix + "User Management";
        UserManagementCtrl.Load();
    }

    render() {
        var Data = AppState.UserManagement.DataGrid.Data || [];
        var badgeHtml;

        var RowsHtml = Object.keys(Data).map(function (rowKey) {
            var item = Data[rowKey];
            switch (status) {
                case 'suspended': badgeHtml = <span className="BadgeDot suspended">Suspended</span>; break;
                default: badgeHtml = <span className="BadgeDot active">Active</span>; break;
            }
            var isChecked = AppState.UserManagement.Selected.includes(item.id);
            var CSS = classNames("PanelItem", { "isChecked": isChecked });
            return (
                <div className={CSS} key={item.id}>
                    <div className="PanelItemBody">
                        <div className="row narrow-gutter">
                            <div className="col-auto col-middle">
                                <label className="FormCheckbox">
                                    <input
                                        type='checkbox'
                                        className="FormCheckboxInput"
                                        onChange={() => UserManagementCtrl.itemCheck(item.id)}
                                        checked={isChecked}
                                    />
                                    <span className="FormCheckboxUI" aria-hidden={true}></span>

                                </label>
                            </div>
                            <div className="col-auto col-middle">
                                <Avatar Config={item} />
                            </div>
                            <div className="col-fluid col-sm-3 col-middle pl-24">
                                <div>
                                    <button className="btnLink" onClick={ ()=>UserManagementEdit.Open(item.id)}><b>{item.fullname}</b></button>
                                </div>
                                <div className="text-muted">{item.role}</div>
                            </div>
                            <div className="col-2 col-middle hidden-xxs hidden-xs">
                                <div className="ts-12 text-muted">
                                    Username
                                </div>
                                {item.name}
                            </div>
                            <div className="col-fluid col-sm-2 col-middle hidden-xxs">
                                <div className="ts-12 text-muted">
                                    Status
                                </div>
                                {badgeHtml}
                            </div>
                            <div className="col-fluid col-middle text-ellipsis hidden-xxs hidden-xs">{item.email}</div>

                            <div className="col-auto col-middle text-right">
                                <UserManagementDropdown>
                                    <button className="item" onClick={UserManagementEdit.Open.bind(null, item.id)}>Edit account</button>
                                    <button className="item" onClick={UserManagementEdit.Open.bind(null, item.id)}>Remove account</button>
                                </UserManagementDropdown>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div>
                <div className="container ">
                </div>

                <div className="container size-800 pt-0 pb-48">
                    <h1 className="siteHeading">User Management</h1>

                    <div className="PanelStructuredff">
                        <div className="PanelSectionff">
                            <div className="flex-space">
                                <div className="flex-line">
                                    {
                                        AppState.UserManagement.Selected.length > 0 ?
                                            <div className="">
                                                <button className="btn secondary hasBadge mr-12" onClick={() => UserManagementCtrl.EraseSelected()}>
                                                    Erase selected
                                                    <span className="badge">{AppState.UserManagement.Selected.length}</span>
                                                </button>
                                                <button className="btnLink mr-12" onClick={() => UserManagementCtrl.SelectNone()}>Select none</button>
                                            </div>
                                            : null

                                    }
                                            <div className="">
                                                <button className="btnLink mr-12" onClick={() => UserManagementCtrl.SelectAll()}>Select all</button>
                                            </div>

                                    <span className="mr-12">{AppState.UserManagement.DataGrid.total} accounts in total</span>
                                </div>
                                <button className="btn primary siteAction" onClick={
                                    () => UserManagementEdit.New()
                                }>Add account</button>
                            </div>
                        </div>
                        <div className="pt-24 PanelContentff">

                            <div className="pb-8" key={AppState.UserManagement.DataGrid.page}>
                                <AnimItems>
                                    {RowsHtml}
                                </AnimItems>
                            </div>
                            <DataGridFooterView Config={AppState.UserManagement.DataGrid} />

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

*/ 
